export enum ExPathOperators {
    Equal = " = ",
    NotEqual = " != ",
    LessThan = " < ",
    LessThanOrEqualTo = " <= ",
    GreaterThan = " > ",
    GreaterThanOrEqualTo = " >= ",
    Or = " or ",
    And = " and ",
}

export type TMapLookup<T> = Map<string, T>;
export type MxObject = mendix.lib.MxObject;
export type MxContext = mendix.lib.MxContext;
export type Form = mxui.lib.form._FormBase;
export type SortSpecifies = mx.Sort[];

export interface IObjectLookup<T> { [id: string]: T; }
export interface IParam {
    paramName: string;
    paramValue: any;
}
export interface IFilterReference {
    [ref: string]: { attributes: string[] };
}
export interface IButtonConfigurations {
    buttonLabel: string;
    buttonClickMf: string;
    buttonClass: string;
    buttonStyle: string;
    buttonVisible: string;
}
export interface IAdditionalButtonConfigurations extends IButtonConfigurations {
    buttonConfirmationRequired: boolean;
    buttonConfirmationQuestion: string;
    alwaysActive: boolean;
}
export interface IAttributeSpecifies {
    operator: ExPathOperators;
    name: string;
    attributeOperator: ExPathOperators;
    value: string | number | boolean;
}
